module.exports = __webpack_public_path__ + "img/FixedTime.5f4f65be.svg";